import { Product } from '../stores/posStore';

interface ProductCardProps {
  product: Product;
  onAddToCart: (product: Product) => void;
}

export default function ProductCard({ product, onAddToCart }: ProductCardProps): JSX.Element {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 hover:shadow-md transition-shadow">
      <div className="bg-gray-100 h-24 rounded mb-2 flex items-center justify-center">
        <span className="text-gray-400 text-sm">No image</span>
      </div>
      <h3 className="font-semibold text-sm text-gray-900 line-clamp-2">{product.name}</h3>
      <p className="text-xs text-gray-600 line-clamp-1 mb-2">{product.description}</p>
      <div className="flex items-center justify-between">
        <span className="text-lg font-bold text-blue-600">₦{product.price}</span>
        <button
          onClick={() => onAddToCart(product)}
          className="bg-blue-600 text-white px-3 py-1 rounded text-sm font-medium hover:bg-blue-700 transition-colors"
        >
          Add
        </button>
      </div>
    </div>
  );
}
